import React from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import { bindActionCreators } from 'redux'
import { TimeStream, renderMoney } from '../../utils'
import { WKVisible } from '../../components/wk'
import * as relayAction from '../../actions/relays'


class LectureRelayListItem extends React.Component {
    getRelayPercentFee (money, percent) {
        return money * percent / 100
    }
    onClickRelay (lecture, e) {
        e.stopPropagation()
        this.props.relaySetCurrentLecture(lecture)
        this.props.relayPostLectureCheck(lecture.id)
    }
    onClickLecture (id) {
        window.location = `/lecture/${id}`
    }
    render() {
        const lecture = this.props.lecture
        return (
            <div onClick={e => this.onClickRelay(lecture, e)} className="box margin-bottom">
                <a href="javascript:;">
                    <div className="weui-flex border-line weui-padding">
                        <div className="weui-flex__item flex_3 lecture-img background-image" style={{ backgroundImage: `url(${lecture.cover_url})` }}>
                        </div>
                        <div className="weui-flex__item flex_9 padding-line overflow-hidden">
                            <p className="text-ellipsis big-font">{ lecture.name }</p>
                            <p className="text-minor">
                                <span>{ TimeStream(lecture.start_timestamp) }</span>
                                <span className="padding-left">{lecture.popular}人气</span>
                            </p>
                            <WKVisible create={lecture.money > 0}>
                                <p className="text-minor">学费:¥{renderMoney(lecture.money)}（转载抽成
                                    <span className="key-num">
                                        ¥{renderMoney(this.getRelayPercentFee(lecture.money, lecture.relay_percent))}
                                    </span>）
                                </p>
                            </WKVisible>
                            <WKVisible create={lecture.money === 0 || lecture.money == null}>
                                <p className="text-minor">免费课</p>
                            </WKVisible>
                        </div>
                    </div>
                </a>
                {/* <div className="border-top-line text-right weui-padding" style={{ lineHeight: 1 }}>
                    <WKVisible create={lecture.relay_fee > 0}>
                        <a href="javascript:;" onClick={e => this.onClickRelay(lecture, e)} className="weui-btn weui-btn_mini weui-btn_primary">支付{renderMoney(lecture.relay_fee)}转播</a>
                    </WKVisible>
                    <WKVisible create={lecture.relay_fee === 0}>
                        <a href="javascript:;" onClick={e => this.onClickRelay(lecture, e)} className="weui-btn weui-btn_mini weui-btn_primary">点击免费转播</a>
                    </WKVisible>
                </div> */}
            </div>
        )
    }
}


export default connect(null, dispatch => bindActionCreators({ ...relayAction }, dispatch))(LectureRelayListItem)



// WEBPACK FOOTER //
// ./src/components/relays/RelayLectureListItem.js